module.exports = __webpack_public_path__ + "static/media/fvs_valve1_85.af975c6b.jpg";